import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./Modal.css";

const ModalFooter = (props) => (
  <div className={classnames(styles.block, styles.footer)}>{props.children}</div>
);

ModalFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModalFooter;
